module.exports = __webpack_public_path__ + "static/img/gn.36a3e9a3.svg";